import { useMemo } from 'react';
import {
  ApiErrorResponse,
  GetApiErrorMessage,
  createApiErrorTranslator,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './useInputDataActions.translations.json';
const { addTranslations, t, exists } = i18nNsFactory(
  'input-data-sample-detail',
);
addTranslations(translations);

const translateMutationError: GetApiErrorMessage = createApiErrorTranslator({
  t,
  exists,
});

export function inputEditError(
  loadingStatus?: string,
  activeVersionId?: number | null,
  columnCount?: number | null,
): string | null {
  if (loadingStatus === 'NO_SAMPLE') {
    return loadingStatus;
  }
  if (!activeVersionId) {
    return 'no-active-version';
  }
  if (!columnCount) {
    return 'no-dimensions-indicators';
  }

  return null;
}

export function useInputDetailsError(detailsError?: ApiErrorResponse | null) {
  return useMemo(() => {
    if (detailsError) {
      const apiError = (detailsError.response?.data.errors ?? [])[0];
      if (apiError) {
        return translateMutationError(apiError.code, apiError.meta);
      }
    }
    return undefined;
  }, [detailsError]);
}
